import instance, { useTable } from 'api';
import { useCallback, useEffect, useRef, useState } from 'react';
import './ConnectionsPage.scss';
import { ModalAddConnection } from './modals/ModalAddConnection';
import { AllConnectionsList } from './AllConnectionsList';
import { PendingConnectionsRequests } from './PendingConnectionsRequests';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectComponentResources,
    updateUserDiscoverableStatus,
} from 'reducers/componentResources';
import { endpoints } from 'endpoints.config';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { ItemConnectionModel } from './items/ItemConnection';
type Props = {
    goBack?: () => void;
    isHideHeaders?: boolean;
    activeTabParent?: string
};

export const ConnectionsPage: React.FC<Props> = ({ goBack, isHideHeaders, activeTabParent }) => {
    const { userInfo } = useSelector(selectComponentResources);
    const dispatch = useDispatch();
    const [showAddConnection, setShowAddConnection] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState('connections');
    const [isDiscoverAble, setIsDisconverAble] = useState<boolean>(true);
    const { t } = useTranslation('network');
    const connectionsListRef = useRef<any>(null);
    const companyName = localStorage?.getItem("companyName")

    const transactionsTable = useTable<ItemConnectionModel, any>({

        url: `${endpoints.networkmodule.getNetworkConnections}`,

        bClearFilters: true,

    });

    const handleAddConClick = useCallback(() => {
        setShowAddConnection(true);
    }, []);
    const handleDiscoverAble = () => {
        setIsDisconverAble((prevISDiscoverAble) => {
            instance
                .post(endpoints.networkmodule.editNetworkConfigs, {
                    bNetworkDiscoverable: prevISDiscoverAble === true ? 0 : 1,
                })
                .then(() => { })
                .catch(() => { });

            dispatch(updateUserDiscoverableStatus(!prevISDiscoverAble));
            return !prevISDiscoverAble;
        });
    };

    useEffect(() => {
        setIsDisconverAble(userInfo?.bNetworkDiscoverable ?? false);
    }, [userInfo?.bNetworkDiscoverable]);
    const handleCopy = () => {
        navigator.clipboard
            .writeText(userInfo?.networkID ?? '')
            .then(() => {
                toast(t('copiedToClipboard', { ns: 'common' }));
            })
            .catch((err) => {
                toast(t('failedToCopy', { ns: 'common' }));
            });
    };

    return (
        <div className="IbaneraNetworkWrapper">
            {goBack && (
                <div className="Back" onClick={goBack}>
                    <span className="notranslate" translate="no">{t('back', { ns: 'common' })}</span>
                </div>
            )}
            {!isHideHeaders && (
                <div className="RestrictWidth">
                    <div className="IbaneraNetworkHeader">
                       {companyName && <h1 className="notranslate" translate="no">{t(`${companyName.replace(/\s+/g, '_')}`)}</h1>}
                    </div>
                </div>
            )}
            <div className="row-container-options">
                {/* First label */}
                <div className="label-item-options" onClick={handleDiscoverAble}>
                    <img
                        src={
                            isDiscoverAble
                                ? `\\assets\\${companyName?.toLowerCase()}\\Icon_Form_01.png`
                                : `\\assets\\${companyName?.toLowerCase()}\\not_discoverable.png`
                        }
                        alt="icon"
                        className="icon-options"
                    />
                    <span className="title-options notranslate" translate="no" style={isDiscoverAble ? {} : { color: 'red' }}>
                        {t('discoverable')}
                    </span>
                </div>

                {/* Second label */}
                <div className="label-item-options">
                    <img
                        src={`\\assets\\${companyName?.toLowerCase()}\\copy_icon.png`}
                        alt="icon"
                        className="icon-options"
                        style={{ padding: 7 }}
                    />
                    <span className="title-options" onClick={handleCopy}>
                        Network ID: {userInfo?.networkID ?? ''}
                    </span>
                </div>

                <div className="label-item-options" onClick={handleAddConClick}>
                    <img
                        src={`\\assets\\${companyName?.toLowerCase()}\\pending_request.png`}
                        alt="icon"
                        className="icon-options"
                        style={{ padding: 7 }}
                    />
                    <span className="title-options notranslate" translate="no">{t('addConnection')}</span>
                </div>
            </div>
            <div className="tab-container">
                {/* Tab Headers */}
                {!isHideHeaders && (
                    <div className="tab-header">
                        <button
                            className={`tab-button ${activeTab === 'connections' ? 'active' : ''}`}
                            onClick={() => setActiveTab('connections')}
                        >
                            {t('connections')}
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
                            onClick={() => setActiveTab('requests')}
                        >
                            {t('connectionRequests')}
                        </button>
                    </div>
                )}

                {/* Tab Content */}
                <div className="tab-content">
                    {activeTab === 'connections' && <AllConnectionsList ref={connectionsListRef} activeTabParent={activeTabParent} transactionsTable={transactionsTable}/>}
                    {activeTab === 'requests' && (
                        <PendingConnectionsRequests ref={connectionsListRef} />
                    )}
                </div>
            </div>
            {showAddConnection && (
                <ModalAddConnection
                    closeModal={(status) => {
                        setShowAddConnection(false);
                        if (status) {
                            connectionsListRef.current?.refreshData();
                        }
                    }}
                />
            )}
        </div>
    );
};
